import axios from '../base/axios';
import API_KEY from './key';

const GET_TVTRENDING = 'flixfrenzy/redux/GET_TVTRENDING';

// eslint-disable-next-line default-param-last
const tvTrendingReducer = (state = [], action) => {
  switch (action.type) {
    case GET_TVTRENDING:
      return action.payload;
    default:
      return state;
  }
};

export const getTvTrending = () => (dispatch) => {
  axios.get(`trending/tv/week?api_key=${API_KEY}&language=en-US`).then((res) => {
    dispatch({
      type: GET_TVTRENDING,
      payload: res.data,
    });
  });
};

export default tvTrendingReducer;
